import { render, staticRenderFns } from "./IconSwitchVerticalSolid.vue?vue&type=template&id=f1e8cacc"
import script from "./IconSwitchVerticalSolid.vue?vue&type=script&lang=js"
export * from "./IconSwitchVerticalSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports